import { createFeature, createReducer, on } from "@ngrx/store";
import { EquipmentLocationFormOptions } from "../../interfaces";
import * as EquipmentLocationFormActions from './equipment-location-form.actions';
import { Address } from "clicklease-ui-elements";

/**
* Initial state of the Personal Information Data.
* 
* @const initialState
*/
const initialState: EquipmentLocationFormOptions = {
    equipmentLocation: {
        city: '',
        county: '',
        state: '',
        street: '',
        zipcode: ''
    },
    loading: false,
    isSubmittingSuccess: false,
    isSubmittingError: false
};

const updateEquipmentLocationDataFunction: any =
    (state: EquipmentLocationFormOptions, action: { locationData: Address }) => ({ ...state, bankAccounData: { ...action.locationData }, loading: true, isSubmittingSuccess: false, isSubmittingError: false });

const updateEquipmentLocationDataSuccessFunction: any =
    (state: EquipmentLocationFormOptions) => ({ ...state, loading: false, isSubmittingSuccess: true, isSubmittingError: false });

const updateEquipmentLocationDataErrorFunction: any =
    (state: EquipmentLocationFormOptions) => ({ ...state, loading: false, isSubmittingSuccess: false, isSubmittingError: true });

const resetSubmittingEquipmentLocationFormFunction: any =
    (state: EquipmentLocationFormOptions) => ({ ...initialState });

const equipmentLocationFormReducer = createReducer(
    initialState,
    on(EquipmentLocationFormActions.updateEquipmentLocationData, updateEquipmentLocationDataFunction),
    on(EquipmentLocationFormActions.updateEquipmentLocationDataSuccess, updateEquipmentLocationDataSuccessFunction),
    on(EquipmentLocationFormActions.updateEquipmentLocationDataError, updateEquipmentLocationDataErrorFunction),
    on(EquipmentLocationFormActions.resetSubmittingEquipmentLocationForm, resetSubmittingEquipmentLocationFormFunction)
);
/**
 * Reducer function to handle state transitions for Personal Iformation Data 
 * feature.
 * 
 * @const EquipmentLocationFormFeature
 */
export const EquipmentLocationFormFeature = createFeature({
    name: 'equipmentLocationForm',
    reducer: equipmentLocationFormReducer
});